import { create } from 'zustand';

export interface PlayerIdentity {
  uid: string;
  displayName: string;
  playerName: string;
  essence: number;
}

interface GameStore {
  user: PlayerIdentity | null;
  chatModel: string | null;
  evalModel: string | null;
  setUser: (u: PlayerIdentity | null) => void;
  setChatModel: (model: string | null) => void;
  setEvalModel: (model: string | null) => void;
  updatePlayerName: (name: string) => void;
  updateEssence: (essence: number) => void;
}

export const useGameStore = create<GameStore>((set) => ({
  user: null,
  chatModel: null,
  evalModel: null,
  setUser: (user) => set({ user }),
  setChatModel: (chatModel) => set({ chatModel }),
  setEvalModel: (evalModel) => set({ evalModel }),
  updatePlayerName: (playerName) =>
    set((s) => (s.user ? { user: { ...s.user, playerName } } : s)),
  updateEssence: (essence) =>
    set((s) => (s.user ? { user: { ...s.user, essence } } : s)),
}));
